export default __webpack_public_path__ + "static/media/gangdonggu-seongnaedong-redevelopment-2.5cac28fc.jpg";